import axios from 'axios'
import * as accessTokenInfo from "../../accessToken";

export const postRecipe = ({commit, dispatch}, payload) => {
      
    axios.post('/recipe/save.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => { 
        commit('unsetOverlayState')

        if(res.data.status) {
            dispatch('fetchRecipe')
        } else {
        }

    })
    .catch(error => {        
        console.log(error)
        commit('setAlertBox', {title: 'message.error', message: 'Error: Please try again!!'})                
    })

}

export const postRecipeAll = ({state, commit, dispatch}) => {

    let totalRows = 0
    commit('setAlert', {message: 'Processing...'})          
    state.list.filter(t => t.updated == 1).forEach(recipe => {
        axios.post('/recipe/save.php', recipe, accessTokenInfo.accessTokenInfo())
        .then(res => { 
            commit('unsetOverlayState')
            //console.log(JSON.stringify(res.data))
            if(res.data.status) {
                //
                recipe.suggested_inventory_expense_sheet.forEach(inventory => {
                    inventory.master = true
                    dispatch('postRecipeInventory', inventory)
                })
                
            } else {
                commit('setAlertBox', {title: 'message.error', message: res.data.message})    
            }

        })
        .catch(error => {        
            console.log(error)
            commit('setAlertBox', {title: 'message.error', message: 'Error: Please try again!!'})                
        })
        totalRows = totalRows + 1
    })
    if(totalRows >= state.list.filter(t => t.updated == 1).length) {
        setTimeout(() => {
            commit('setAlertBox', {title: 'message.success', message: 'Todo actualizado'})        
        }, 5000);        
    }
    
}

export const deleteRecipe = ({commit, dispatch}, payload) => {
      
    axios.post('/recipe/delete.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => { 
        commit('unsetOverlayState')

        if(res.data.status) {
            dispatch('fetchRecipe')
        } else {
            commit('setAlertBox', {title: 'message.error', message: res.data.message})    
        }

    })
    .catch(error => {

        
        console.log(error)
commit('setAlertBox', {title: 'message.error', message: 'Error: Please try again!!'})                
    })

}

export const fetchRecipe = ({commit}) => {

    axios.get('/customerPortal/catering/recipe.php', accessTokenInfo.accessTokenInfo())
    .then(res => { 
        
        commit('unsetOverlayState')

        commit('setRecipeList', res.data.response)    
        
    })
    .catch(error => {
        console.log(error)
        commit('setAlertBox', {title: 'message.error', message: 'Error: Please try again!!'})                
    })

}

export const postRecipeInventory = ({commit, dispatch}, payload) => {
      
    axios.post('/recipe/inventory/save.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => { 
        commit('unsetOverlayState')

        if(res.data.status) {
            if(!payload.master) {
                dispatch('fetchRecipe')
            }            
        } else {
            commit('setAlertBox', {title: 'message.error', message: res.data.message})    
        }

    })
    .catch(error => {

        
        console.log(error)
commit('setAlertBox', {title: 'message.error', message: 'Error: Please try again!!'})                
    })

}

export const deleteRecipeInventory = ({commit, dispatch}, payload) => {
      
    axios.post('/recipe/inventory/delete.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => { 
        commit('unsetOverlayState')

        if(res.data.status) {
            dispatch('fetchRecipe')
        } else {
            commit('setAlertBox', {title: 'message.error', message: res.data.message})    
        }

    })
    .catch(error => {

        
        console.log(error)
commit('setAlertBox', {title: 'message.error', message: 'Error: Please try again!!'})                
    })

}



// WEBPACK FOOTER //
// ./src/store/modules/recipe/actions.js